import React from "react";
import SidebarComponent from "../../components/pages/SidebarComponent";

const SidebarScreen = () => {
  return <SidebarComponent />;
};

export default SidebarScreen;
